import { getContainingComponent } from "ceres/app/helper/utils";

const browserDetect = require("detect-browser");
const NotificationService = require("ceres/app/services/NotificationService");
const AutoFocusService = require("ceres/app/services/AutoFocusService");

import { debounce } from "ceres/app/helper/debounce";
import Vue from "vue";
import { Swiper } from "swiper";
import { getStyle } from "ceres/app/helper/dom";
import { detectPassiveEvents } from "ceres/app/helper/featureDetect";
import HeaderScroller from "ceres/app/helper/HeaderScroller";

// Frontend end scripts
// eslint-disable-next-line
const headerCollapses = [];

function HeaderCollapse(selector)
{
    headerCollapses.push(selector);
    $(function()
    {
        $(selector).on("show.bs.collapse", () =>
        {
            headerCollapses.forEach(element =>
            {
                if (!$(element).is(selector))
                {
                    $(element).collapse("hide");
                }
            });
        });

    });
}

function CeresMain()
{
    const browser = browserDetect.detect();

    if (browser)
    {
        if (browser.name)
        {
            $("html").addClass(browser.name);
        }
        else
        {
            $("html").addClass("unknown-browser");
        }
        if (browser.os)
        {
            $("html").addClass(browser.os.toLowerCase().replace(/[^a-zA-Z0-9\-]/g, "-").replace("windows", "windows windows"));
        }
        else
        {
            $("html").addClass("unknown-os");
        }
    }
    else
    {
        $("html").addClass("unknown-detect");
    }

    window.onpopstate = function(event)
    {
        if (event.state && event.state.requireReload)
        {
            window.location.reload();
        }
    };

    // init bootstrap tooltips
    document.querySelectorAll("[data-toggle=\"tooltip\"]").forEach(el =>
    {
        $(el).tooltip();
    });

    HeaderCollapse("#countrySettings");
    HeaderCollapse("#currencySelect");
    HeaderCollapse("#searchBox");

    const $mainNavbarCollapse = $("#mainNavbarCollapse");

    // prevent hidding collapses in the shopbuilder, for editing search bar results
    if (!App.isShopBuilder)
    {
        $(document).on("click", function(evt)
        {
            headerCollapses.forEach(element =>
            {
                if (evt.target !== element && $(evt.target).parents(element).length <= 0)
                {
                    $(element).collapse("hide");
                }
            });
        });
    }

    $mainNavbarCollapse.collapse("hide");

    // Add click listener outside the navigation to close it
    $mainNavbarCollapse.on("show.bs.collapse", function()
    {
        $(".main").one("click", closeNav);
    });

    $mainNavbarCollapse.on("hide.bs.collapse", function()
    {
        $(".main").off("click", closeNav);
    });

    function closeNav()
    {
        $("#mainNavbarCollapse").collapse("hide");
    }

    $(function()
    {
        const offset = 250;
        const duration = 300;
        const trusted = Math.round($(document).height() * 80 / 100);


        let isDesktop = window.matchMedia("(min-width: 768px)").matches;

        AutoFocusService.autoFocus();

        $("#searchBox").on("shown.bs.collapse", function()
        {
            const searchInput = document.querySelector("input.search-input");

            if (searchInput)
            {
                searchInput.focus();
            }
        });

        window.addEventListener("scroll", function()
        {
                if($(window).scrollTop() >= 205){
                    // $(".header__search-container > div").detach().appendTo(".sticky-header__search-receiver");
                    $(".sticky-header").addClass("show");
                    $('#page-header .basket-preview-wrapper').addClass("d-none")
                }else{
                    // $(".sticky-header__search-receiver > div").detach().appendTo(".header__search-container");
                    $(".sticky-header").removeClass("show");
                    $('#page-header .basket-preview-wrapper').removeClass("d-none")
                }

                if ($(window).scrollTop() > offset)
                {
                    $(".back-to-top-new").fadeIn(duration);
                    $(".back-to-top-center").fadeIn(duration);
                }
                else
                {
                    $(".back-to-top-new").fadeOut(duration);
                    $(".back-to-top-center").fadeOut(duration);
                }

                if(window.innerWidth >= 586 && window.innerWidth <= 1400 ){
                    if ($(window).scrollTop() > 200)
                    {
                        document.getElementById('trustbadge-container-98e3dadd90eb493088abdc5597a70810').classList.add("trustbadge--fade-out")
                    }
                    else{
                        document.getElementById('trustbadge-container-98e3dadd90eb493088abdc5597a70810').classList.remove("trustbadge--fade-out")
                    }
                }
        }, detectPassiveEvents() ? { passive: true } : false );

        window.addEventListener("resize", function()
        {
            isDesktop = window.matchMedia("(min-width: 768px)").matches;
        });

        $(".back-to-top-new").on("click", function(event)
        {
            event.preventDefault();

            $("html, body").animate({ scrollTop: 0 }, duration);

            return false;
        });

        $(".back-to-top-center").on("click", function(event)
        {
            event.preventDefault();

            $("html, body").animate({ scrollTop: 0 }, duration);

            return false;
        });

        $("#accountMenuList").on("click", function()
        {
            $("#countrySettings").collapse("hide");
            $("#searchBox").collapse("hide");
            $("#currencySelect").collapse("hide");
        });

        fixPopperZIndexes();

        // Emit event for Sticky Containers to update
        $(".collapse").on("show.bs.collapse hide.bs.collapse", function()
        {
            this.dispatchEvent(new CustomEvent("updateStickyContainer",
                {
                    bubbles: true
                }));
        });

        // custom JS

        $('body').on("click", "button.article-card__btn--show", function(){
            $(this).closest("a").click();
        });

        var s1 = new Swiper("#home-slider", {
            // pagination: ".swiper-pagination",
            // nextButton: ".swiper-button-next",
            // prevButton: ".swiper-button-prev",
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            // paginationClickable: true,
            spaceBetween: 30,
            loop: true,
            centeredSlides: true,
            pagination: {
                el: ".swiper-pagination",
                type: "fraction"
            },
            autoplay: {
                delay: 5000
            }
        });

        var s2 = new Swiper("#brand-swiper", {
            slidesPerView: 3,
            spaceBetween: 40,
            loop: true,
            lazy: true,
            // nextButton: ".swiper-button-next.brands",
            // prevButton: ".swiper-button-prev.brands",
            navigation: {
                nextEl: ".brands.swiper-button-next",
                prevEl: ".brands.swiper-button-prev"
            },
            breakpoints: {

                1024: {
                    slidesPerView: 8,
                    spaceBetween: 30
                },
                768: {
                    slidesPerView: 5,
                    spaceBetween: 20
                },
                425: {
                    slidesPerView: 5,
                    spaceBetween: 10
                }
            }
        });

        var s3 = new Swiper('#article-top .swiper-article', {
            slidesPerView: 1,
            spaceBetween: 20,
            nextButton: ".swiper-button-next",
            prevButton: ".swiper-button-prev",
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            pagination: {
                el: "#article-top .swiper-pagination",
                type: "bullets",
                dynamicBullets: true,
            },
            breakpoints: {
                1599: {
                    slidesPerView: 4,
                    spaceBetween: 0,
                },
                1199: {
                    slidesPerView: 4,
                    spaceBetween: 0,
                },
                767: {
                    slidesPerView: 3,
                    spaceBetween: 0,
                },
            },
        });

        s3.on('slideChange', function() { window.dispatchEvent(new Event('resize')); });

        var s4 = new Swiper(".product-slider", {
            slidesPerView: 2,
            loop: false,
            paginationClickable: true,
            //nextButton: ".swiper-button-next",
            //prevButton: ".swiper-button-prev",
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            spaceBetween: 14,
            lazyLoading: true,
            breakpoints: {
                320: {
                    slidesPerView: 2,
                    spaceBetweenSlides: 10
                },
                480: {
                    slidesPerView: 2,
                    spaceBetweenSlides: 15
                },
                768: {
                    slidesPerView: 3,
                    spaceBetweenSlides: 15
                },
                992: {
                    slidesPerView: 4,
                    spaceBetweenSlides: 15
                }

            }
        });

        s4.on('slideChange', function() { window.dispatchEvent(new Event('resize')); });

        var s7 = new Swiper(".similar-swiper", {
            slidesPerView: 4,
            spaceBetween: 0,
            //nextButton: ".swiper-button-next",
            //prevButton: ".swiper-button-prev",
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            breakpoints: {
                1599: {
                    slidesPerView: 4,
                    spaceBetween: 0,
                },
                1199: {
                    slidesPerView: 3,
                    spaceBetween: 0,
                },
                767: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
            },
        });

        window.dispatchEvent(new Event('resize'));

        s7.on('slideChange', function() { window.dispatchEvent(new Event('resize')); });

        var articleNewInit = false;
        var articleSaleInit = false;

        if(!articleNewInit){

            var s5 = new Swiper('#article-new .swiper-article', {
                slidesPerView: 1,
                spaceBetween: 20,
                //nextButton: ".article.swiper-button-next",
                //prevButton: ".article.swiper-button-prev",
                navigation: {
                    nextEl: '.swiper-article .swiper-button-next',
                    prevEl: '.swiper-article .swiper-button-prev'
                },
                pagination: {
                    el: ".swiper-article .swiper-pagination",
                    type: "bullets",
                    dynamicBullets: true,
                },
                breakpoints: {
                    1599: {
                        slidesPerView: 4,
                        spaceBetween: 0,
                    },
                    1199: {
                        slidesPerView: 4,
                        spaceBetween: 0,
                    },
                    767: {
                        slidesPerView: 3,
                        spaceBetween: 0,
                    },
                },
            });

            s5.on('slideChange', function() { window.dispatchEvent(new Event('resize')); });

            articleNewInit = true;
        }

        $('#article-top-tab').click(function(){
            $('#article-new, #article-sale').hide();
            $('#article-top').show();
        });


        if(!articleSaleInit){
            var s6 = new Swiper('#article-sale .swiper-article', {
                slidesPerView: 1,
                spaceBetween: 0,
                //nextButton: ".article.swiper-button-next",
                //prevButton: ".article.swiper-button-prev",
                navigation: {
                    nextEl: '.article.swiper-button-next',
                    prevEl: '.article.swiper-button-prev'
                },
                pagination: {
                    el: "#article-sale .swiper-pagination",
                    type: "bullets",
                    dynamicBullets: true,
                },
                breakpoints: {
                    1599: {
                        slidesPerView: 5,
                        spaceBetween: 0,
                    },
                    1199: {
                        slidesPerView: 4,
                        spaceBetween: 0,
                    },
                    767: {
                        slidesPerView: 3,
                        spaceBetween: 0,
                    },
                },
            });

            articleSaleInit = true;
        }

        $('.footer-nav__outer-list > li > a').on('click', function(e){
            e.preventDefault();
            if($(this).next('.footer-nav__inner-list').css('display') == 'none'){
                $(this).next('.footer-nav__inner-list').show().addClass('toggled-footer-subnav');
                return false;
            }else if($(this).next('.footer-nav__inner-list').hasClass('toggled-footer-subnav')){
                $(this).next('.footer-nav__inner-list').hide().removeClass('toggled-footer-subnav');
            }else{
                return false;
            }

        });

        $('body').on('click', '.article-card__add-to-basket .article-card__btn', function(ev){
            ev.preventDefault();
            $($(this).closest('.article-card')).find('.add-to-basket-container .article-card__btn').click();
        });

        if($('.single').length){

            $('.single-item__top-container .breadcrumb').find('.breadcrumb-item:last').remove();
            $('.single-item__top-container .breadcrumb').find('.breadcrumb-item:last a').css('color', '#ee4f53');

            // INFO: Nährwerte
            if($('.Naehrwerte').length){
                var naehrwerte = $('.Naehrwerte').html();
                var naehrwerteArr = naehrwerte.split('<br>');

                for(var i in naehrwerteArr){
                    naehrwerteArr[i] = naehrwerteArr[i].split(': ');
                }

                var tableString = '<table><tbody>';
                for(var j in naehrwerteArr){
                    var secTd = typeof naehrwerteArr[j][1] !== 'undefined' ? naehrwerteArr[j][1] : '';
                    tableString += '<tr><td><b>'+naehrwerteArr[j][0]+'</b></td><td>'+secTd+'</td></tr>'
                }

                tableString += '</tbody></table>';

                $('.Naehrwerte').html(tableString);
            }

            $('.single-item__breadcrumb li a').on('click', function(){
                window.location.href = $(this).attr('href');
            });

            $('a[data-lightbox="single-big-image-gallery"]').click(function(){
                $('.lb-next').html('<i class="fa fa-chevron-right"></i>');
                $('.lb-prev').html('<i class="fa fa-chevron-left"></i>');
            });

            $('.lightbox').prepend('<div class="lightbox-close"><i class="fa fa-close"></i></div>')

        }

        $('body').on('click', '.lightbox-close, .lightbox-close .fa-close', function(){
            $('.lightbox').click();
            lightbox.end();
        });

        $('.toggle-single-item-info-mobile').on('click', function(){
            $('.single-item__top-info--mobile').toggle();
            if($('.single-item__top-info--mobile-icon').hasClass('fa-chevron-down')){
                $('.single-item__top-info--mobile-icon').removeClass('fa-chevron-down').addClass('fa-chevron-up');
            }else{
                $('.single-item__top-info--mobile-icon').removeClass('fa-chevron-up').addClass('fa-chevron-down');
            }
        });

        $(document).on('click', '.checkout__zutaten-btn', function(){

            $(this).next('.basket-items-list__info-container--left-bottom-checkout--details').toggle();

        });

        $('.homepage-contact-toggle').on('click', function(){

            if($(this).hasClass('homepage-contact-open')){
                $(this).removeClass('homepage-contact-open');
                $('.homepage-contact').css('right', '-320px');
            }else{
                $(this).addClass('homepage-contact-open');
                $('.homepage-contact').css('right', '0px');
            }

        });

        $(document).on('click', '#add-item-to-basket-overlay-custom [data-dismiss="modal"], ' +
            '#add-item-to-basket-overlay-custom .item-confirm-special-case-close .basket-overlay-modal__basket', function(){

            $('#add-item-to-basket-overlay-custom .modal').modal('hide');
            $('.modal-backdrop').remove();
            $('#add-item-to-basket-overlay .modal').removeClass('hidden-imp');
        }).on('click', '.modal-backdrop.fade', function(){
            $('.modal-backdrop').remove();
            $('#add-item-to-basket-overlay .modal').removeClass('hidden-imp');
        }).on('mousedown', '.fl-add-to-cart-btn', function(){
            $('#add-item-to-basket-overlay .modal').addClass('hidden-imp');
        }).on('click', '.fl-add-to-cart-btn', function(){
            $('#add-item-to-basket-overlay .modal').modal('hide');
        });

        $(document).on('click', '.js-faq-box__question', function(){
            $(this).parent().find(".js-faq-box__content").fadeToggle();
            $(this).parent().find(".fas").toggleClass("fa-chevron-down");
            $(this).parent().find(".fas").toggleClass("fa-chevron-up");
        });

        $("body").click(function(event)
        {
            if(!(event.target.closest(".basket-preview-wrapper"))){
                $('body').removeClass("basket-open")
            }
        });

        if(!!document.querySelector("body").querySelector("#item-number")){
            document.querySelector("body").querySelector("#item-number").addEventListener("keyup", function(ev){
                if(this.value !== "" && ev.keyCode === 13){
                    sendBasketRequest( 'Artikel wurde in den Warenkorb gelegt.', 'Es konnte leider kein Artikel gefunden werden.', '/number_to_basket');
                    this.value = "";
                }
            });

            document.querySelector("body").querySelector(".basket__bottom-container--totals .input-group .input-group-btn").addEventListener("click", function(){
                document.querySelector("body").querySelector("#item-number").value = "";
            })
        }
    });

    // übernahme FL functions aus alten stand
    var refreshBasketForFindologic = function(showModal){

        showModal = showModal || false;

        $('#add-item-to-basket-overlay .modal').modal('hide');

        // wenn basket leer -> mit api item getten und template füllen, html einhängen
        if($('.basket-preview .basket-item-container').length == 0){

            $.get('/rest/io/basket/items', function(res){
                var data = JSON.parse(res).data[0];

                var template = '<div class="basket-item-container basket-small">' +
                    '<div class="basket-item component-loading with-icon sending">' +
                    '<div class="image-container">' +
                    '<img src="'+data.variation.data.images.all[0].urlMiddle+'" alt="'+data.variation.data.texts.name1+'" class="img-basket-small"></div> ' +
                    '<div class="meta-container-wrapper"><div class="meta-container-wrapper-inner"><div class="meta-container"><div>' +
                    '<div class="col-md-12">' +
                    '<a href="'+data.variation.data.texts.urlPath+'" class="item-name">\n' +
                    '                                    '+data.variation.data.texts.name1+'\n' +
                    '                                </a></div> <hr class="basket-items-list__item-name-hr"> ' +
                    '<div class="col-md-12 basket-items-list__info-container"><div class="col-md-6 col-lg-8 col-12 basket-items-list__info-container--left">' +
                    '</div> <div class="col-md-6 col-lg-4 col-12 basket-items-list__info-container--right">' +
                    '<div class="col-md-6 col-lg-4 col-5"><div class="qty-box-container"><div class="quantity"><span href="#" ' +
                    'class="quantity__minus disabled" data-original-title="" title="">-</span> <input type="text" name="ArticleQuantity" value="'+data.quantity+'" size="4"' +
                    ' maxlength="3" data-plenty="quantityInput" class="quantity__input"> <span href="#" class="quantity__plus" data-title="null">+</span></div>' +
                    '</div></div> <div class="col-md-6 col-lg-8 col-7"><div class="item-total-price">'+data.variation.data.prices.default.price.formatted+'*</div> <div class="item-total-price-split">' +
                    '<div class="item-small-prices text-muted"><div>('+data.variation.data.prices.default.basePrice+')</div> <span>inkl. 7% MwSt. | zzgl. ' +
                    '<a href="https://www.sweets-online.com/content/versand" class="versand-link">Versand</a></span></div></div> <div class="item-remove-container">' +
                    '<div class="btn btn-sm item-remove-button"><span>\n' +
                    '                                        Artikel entfernen X\n' +
                    '                                    </span></div></div></div></div></div></div></div></div></div></div></div>';

                $('.basket-list__inner-parent > div:last-child').remove();
                $('.basket-list__inner-parent > div:first-child').html(template);

                // buttons aktivieren
                $('.basket-preview .basketBtn, .basket-preview .checkOutBtn').attr('disabled', false);
                $('.basket-preview .basketBtn, .basket-preview .checkOutBtn').removeClass('disabled');

                // neuestes item getten + modal
                if(showModal){

                    var allItems = JSON.parse(res).data;

                    var lastItemKey = 0;
                    var highestTs = 0;

                    for(var key in allItems){
                        var tsAdded = Date.parse(allItems[key].createdAt);
                        var tsUpdated = Date.parse(allItems[key].updatedAt);

                        if(tsAdded > tsUpdated){
                            if(tsAdded > highestTs){
                                highestTs = tsAdded;
                                lastItemKey = key;
                            }
                        }else{
                            if(tsUpdated > highestTs){
                                highestTs = tsUpdated;
                                lastItemKey = key;
                            }
                        }

                    }

                    var lastItemPrice = allItems[lastItemKey].price; // 1111.11
                    lastItemPrice = lastItemPrice.toLocaleString('de'); // 1.111,11

                    var lastItemPriceArr = lastItemPrice.split(',');
                    if((lastItemPriceArr[1]).length == 1){
                        lastItemPrice = lastItemPrice+'0';
                    }

                    var lastItemQuantity = allItems[lastItemKey].quantity;
                    var lastItemImg = allItems[lastItemKey].variation.data.images.all[0].urlMiddle;
                    var lastItemName = allItems[lastItemKey].variation.data.texts.name1;

                    $('#add-item-to-basket-overlay-custom .modal .modal-body img').attr('src', lastItemImg);
                    $('#add-item-to-basket-overlay-custom .js--add-item-to-basket-modal__quantity').text(lastItemQuantity);
                    $('#add-item-to-basket-overlay-custom .js--add-item-to-basket-modal__name').text(lastItemName);
                    $('#add-item-to-basket-overlay-custom .basket-overlay-modal__price b').text(lastItemPrice+' €');
                    $('#add-item-to-basket-overlay-custom .basket-overlay-modal__basket').removeClass('disabled').attr('disabled', false);

                    $('#add-item-to-basket-overlay-custom .modal').modal('show');



                }

                // summen anpassen
                $.get('/rest/io/basket', function(res){

                    res = JSON.parse(res);

                    // für den header
                    var sum = (res.data.itemSum).toLocaleString('de'); // mit komma als dezimal, punkt als tausender trenner
                    var amount = res.data.itemQuantity;

                    // in der preview
                    // .basket-totals__total-container mit gesamt inkl. versand (basketamount)
                    // .basket-totals-warenwert mit itemsum
                    var total = (res.data.basketAmount).toLocaleString('de');
                    var shipping = (res.data.shippingAmount).toLocaleString('de');
                    if(shipping.indexOf(',') < 0){
                        shipping = shipping+',00';
                    }

                    var sumArr = sum.split(',');
                    if((sumArr[1]).length == 1){
                        sum = sum+'0';
                    }

                    var totalArr = total.split(',');
                    if((totalArr[1]).length == 1){
                        total = total+'0';
                    }

                    $('.basket-preview .cmp-totals .basket-totals-warenwert').text(sum+' €');
                    $('.basket-preview .cmp-totals .basket-totals__total-container').text(total+' €');
                    $('.basket-preview .cmp-totals .basket-totals-shipping').text(shipping+' €');

                    $('.header__user-playground-basket .badge-right').text(amount);
                    $('.header__user-playground-basket .badge').text(sum+' €');

                    $('.toggle-basket-preview img').removeClass('basket-img-with-margin').addClass('basket-img-with-margin').attr('src', 'https://s3-eu-central-1.amazonaws.com/plentymarkets-public-92/mgt7h3rmbzvp/plugin/18/sweetsonline/images/svg/basket-full.svg');

                });

            });

        }else{

            vueApp.$store._actions.loadBasketData[0]();
            // vueApp.$store.state.basket.data.itemQuantity
            // vueApp.$store.state.basket.data.itemSum €

            // neustes item getten + modal
            if(showModal){

                $.get('/rest/io/basket/items', function(res){
                    var allItems = JSON.parse(res).data;

                    var lastItemKey = 0;
                    var highestTs = 0;

                    for(var key in allItems){
                        var tsAdded = Date.parse(allItems[key].createdAt);
                        var tsUpdated = Date.parse(allItems[key].updatedAt);

                        if(tsAdded > tsUpdated){
                            if(tsAdded > highestTs){
                                highestTs = tsAdded;
                                lastItemKey = key;
                            }
                        }else{
                            if(tsUpdated > highestTs){
                                highestTs = tsUpdated;
                                lastItemKey = key;
                            }
                        }

                    }

                    var lastItemPrice = allItems[lastItemKey].price; // 1111.11
                    lastItemPrice = lastItemPrice.toLocaleString('de'); // 1.111,11

                    var lastItemPriceArr = lastItemPrice.split(',');
                    if((lastItemPriceArr[1]).length == 1){
                        lastItemPrice = lastItemPrice+'0';
                    }

                    var lastItemQuantity = allItems[lastItemKey].quantity;
                    var lastItemImg = allItems[lastItemKey].variation.data.images.all[0].urlMiddle;
                    var lastItemName = allItems[lastItemKey].variation.data.texts.name1;

                    $('#add-item-to-basket-overlay-custom .modal .modal-body img').attr('src', lastItemImg);
                    $('#add-item-to-basket-overlay-custom .js--add-item-to-basket-modal__quantity').text(lastItemQuantity);
                    $('#add-item-to-basket-overlay-custom .js--add-item-to-basket-modal__name').text(lastItemName);
                    $('#add-item-to-basket-overlay-custom .basket-overlay-modal__price b').text(lastItemPrice+' €');
                    $('#add-item-to-basket-overlay-custom .basket-overlay-modal__basket').removeClass('disabled').attr('disabled', false);

                    $('#add-item-to-basket-overlay-custom .modal').modal('show');


                });

            }

            $.get('/rest/io/basket', function(res){

                res = JSON.parse(res);

                // für den header
                var sum = (res.data.itemSum).toLocaleString('de'); // mit komma als dezimal, punkt als tausender trenner
                var amount = res.data.itemQuantity;

                // in der preview
                // .basket-totals__total-container mit gesamt inkl. versand (basketamount)
                // .basket-totals-warenwert mit itemsum
                var total = (res.data.basketAmount).toLocaleString('de');
                var shipping = (res.data.shippingAmount).toLocaleString('de');
                if(shipping.indexOf(',') < 0){
                    shipping = shipping+',00';
                }

                var sumArr = sum.split(',');
                if((sumArr[1]).length == 1){
                    sum = sum+'0';
                }

                var totalArr = total.split(',');
                if((totalArr[1]).length == 1){
                    total = total+'0';
                }

                $('.basket-preview .cmp-totals .basket-totals-warenwert').text(sum+' €');
                $('.basket-preview .cmp-totals .basket-totals__total-container').text(total+' €');
                $('.basket-preview .cmp-totals .basket-totals-shipping').text(shipping+' €');

                $('.header__user-playground-basket .badge-right').text(amount);
                $('.header__user-playground-basket .badge').text(sum+' €');

            });

        }

    };

    $('#findologic-basketrefresh-button').click(function(){

        refreshBasketForFindologic(true);

    });
}

window.CeresMain = new CeresMain();
window.CeresNotification = NotificationService;

const showShopNotification = function(event)
{
    if (event.detail.type)
    {
        switch (event.detail.type)
        {
            case "info":
                NotificationService.info(event.detail.message);
                break;
            case "log":
                NotificationService.log(event.detail.message);
                break;
            case "error":
                NotificationService.error(event.detail.message);
                break;
            case "success":
                NotificationService.success(event.detail.message);
                break;
            case "warning":
                NotificationService.warn(event.detail.message);
                break;
            default:
                console.log("no type such as:" + event.detail.type);
                break;
        }
    }
};

document.addEventListener("showShopNotification", showShopNotification);

// fixate the header elements
new HeaderScroller();

$(document).on("shopbuilder.after.drop shopbuilder.after.widget_replace", function(event, eventData, widgetElement)
{
    const parent = widgetElement[1];

    const parentComponent = getContainingComponent(parent);

    const compiled = Vue.compile(widgetElement[0].outerHTML, { delimiters: ["${", "}"] } );
    const component = new Vue({
        store: window.ceresStore,
        render: compiled.render,
        staticRenderFns: compiled.staticRenderFns,
        parent: parentComponent
    });

    component.$mount( widgetElement[0] );
    $(component.$el).find("*").each(function(index, elem)
    {
        $(elem).on("click", function(event)
        {
            event.preventDefault();
        });
    });

    $(component.$el).find(".owl-carousel").on("resized.owl.carousel", function()
    {
        window.dispatchEvent(new Event("resize"));
    });
});

function fixPopperZIndexes()
{
    const elements = document.querySelectorAll(".popover.d-none");

    let counter = elements.length;

    elements.forEach(el =>
    {
        let zIndex = parseInt(getStyle(el, "z-index"));

        if (!isNaN(zIndex))
        {
            zIndex += --counter;

            el.style.zIndex = zIndex;
        }
    });
}
